import BrandChain from '../../sections/BrandChain/BrandChain';
import FundamentalByMrOutlet from '../../sections/fundamentalByOutlets/FundamentalByMrOutlet';
import FundamentalByOutlet from '../../sections/fundamentalByOutlets/FundamentalByOutlet';
import OutletWiseScore from '../../table/OutletWiseScore/OutletWiseScore';

const BBSM = ({ bu }) => {
  return (
    <>
      <FundamentalByOutlet bu={bu} outletChannel="BBSM" />
      <FundamentalByMrOutlet bu={bu} outletChannel="BBSM" />
      <OutletWiseScore title="Product Category R-Score and Gap Report" bu={bu} outletChannel="BBSM" />
      <BrandChain bu={bu} outletChannel="BBSM" />
    </>
  );
};

export default BBSM;
